/**
 * Query Key factory for all consultation queries.
 *
 * @module Consultation
 */

import { Pagination } from "@customTypes/index";


export const consultationQKeys = {
  all: () => ["consultations"] as const,

  allWithFilters: (filters?: {
    userId?: string;
    search?: string;
    pagination?: Partial<Pagination>;
  }) => [...consultationQKeys.all(), { ...filters }] as const,

  patients: () => [...consultationQKeys.all(), "patient"] as const,

  patient: (patientId: string) =>
    [...consultationQKeys.patients(), patientId] as const,

  patientWithFilters: (
    patientId: string,
    filters?: {
      withFilesOnly?: boolean;
      hasPrescription?: boolean;
      pagination?: Partial<Pagination>;
      search?: string;
      consultationId?: string;
      includeArchived?: boolean;
    }
  ) => [...consultationQKeys.patient(patientId), { ...filters }] as const,

  singleConsultations: () =>
    [...consultationQKeys.all(), "singleConsultation"] as const,

  singleConsultation: (consultationId: string) =>
    [...consultationQKeys.singleConsultations(), consultationId] as const,

  treatmentPlans: () =>
    [...consultationQKeys.singleConsultations(), "treatmentPlans"] as const,

  treatmentPlanWithFilters: (
    patientId: string,
    filters?: { pagination?: Partial<Pagination> }
  ) =>
    [...consultationQKeys.treatmentPlans(), patientId, { ...filters }] as const,

  injections: () =>
    [...consultationQKeys.singleConsultations(), "injections"] as const,

  // No need for pagination filters yet, but might come later
  injectionsWithFilters: (consultationId: string) =>
    [...consultationQKeys.injections(), consultationId] as const,
};
